import { ChronicDisease, ChronicDiseaseQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Direction, paginations } from '@dreryk/command-query-ws-client';
import { Message, MessageType } from '@dreryk/react-components';

import { medicalDataTranslationKeys } from '../../../translations';
import { SidePanelLoader } from '../../SidePanelLoader';

type ChronicDiseaseSidePanelListLoaderRenderProps = {
   chronicDiseases: ChronicDisease[];
   refetchChronicDiseases: VoidFunction;
};

type ChronicDiseaseSidePanelListLoaderProps = {
   readonly patientId: number;
   readonly children: (props: ChronicDiseaseSidePanelListLoaderRenderProps) => JSX.Element;
};

export const ChronicDiseaseSidePanelListLoader = (props: ChronicDiseaseSidePanelListLoaderProps): JSX.Element => {
   const {
      data: chronicDiseases,
      loading: chronicDiseasesLoading,
      error: chronicDiseasesError,
      refetch: refetchChronicDiseases,
   } = useCqrsSearch<ChronicDisease>(() => {
      const query = new ChronicDiseaseQuery();
      query.patientId = props.patientId;
      return query;
   }, paginations.all<ChronicDisease>().orderedBy('diagnosisCreationDate', Direction.DESCENDING));

   if (chronicDiseasesLoading) {
      return <SidePanelLoader />;
   }

   if (chronicDiseasesError) {
      return (
         <Message
            testId={'failedToFetchChronicDiseases'}
            label={medicalDataTranslationKeys.failedToFetchMedicalInformation}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      chronicDiseases: chronicDiseases,
      refetchChronicDiseases: refetchChronicDiseases,
   });
};
